export const dataId = 'reports';
const reports = 'reports';
const createModal = `${reports}.createModal`;
const renameModal = `${reports}.renameModal`;
const deleteModal = `${reports}.deleteModal`;
const duplicateModal = `${reports}.duplicateModal`;
const publishTemplate = `${reports}.publishTemplate`;
const publish = `${reports}.publish`;
const deleteReportAnalysis = `${reports}.deleteReportAnalysis`;
const newAnalysisFromTemplateOverlayModal = `${reports}.newAnalysisFromTemplateOverlayModal`;

export default {
    create: {
        tryAgain: `${createModal}.tryAgain`,
        inputName: `${createModal}.inputName`,
        save: `${createModal}.save`,
        cancel: `${createModal}.cancel`,
        createReportTemplate: `${createModal}.create`,
    },
    renameModal: {
        tryAgain: `${renameModal}.tryAgain`,
        inputName: `${renameModal}.inputName`,
        main: `${renameModal}.save`,
        cancel: `${renameModal}.cancel`,
    },
    deleteModal: {
        tryAgain: `${deleteModal}.tryAgain`,
        delete: `${deleteModal}.delete`,
        cancel: `${deleteModal}.cancel`,
    },
    deactivateModal: {
        tryAgain: `${deleteModal}.tryAgain`,
        delete: `${deleteModal}.delete`,
        cancel: `${deleteModal}.cancel`,
    },
    duplicateModal: {
        tryAgain: `${duplicateModal}.tryAgain`,
        inputName: `${duplicateModal}.inputName`,
        save: `${duplicateModal}.save`,
        cancel: `${duplicateModal}.cancel`,
    },
    shareModal: {
        tryAgain: `${reports}.shareModal.tryAgain`,
        main: `${reports}.shareModal.main`,
        cancel: `${reports}.shareModal.cancel`,
    },
    actionsDropdown: `${reports}.actionsDropdown`,
    publishTemplate: {
        inputName: `${publishTemplate}.inputName`,
        main: `${publishTemplate}.save`,
        cancel: `${publishTemplate}.cancel`,
    },
    publish: {
        tryAgain: `${publish}.tryAgain`,
        main: `${publish}.save`,
        cancel: `${publish}.cancel`,
    },
    edit: `${reports}.edit`,
    updateNameAndDescription: `${reports}.updateNameAndDescription`,
    deleteReportAnalysis: {
        delete: `${deleteReportAnalysis}.delete`,
        cancel: `${deleteReportAnalysis}.cancel`,
        tryAgain: `${deleteReportAnalysis}.tryAgain`,
    },
    newAnalysisFromTemplateOverlayModal: {
        main: `${newAnalysisFromTemplateOverlayModal}.saveAndConfirm`,
        optional: `${newAnalysisFromTemplateOverlayModal}.confirm`,
        cancel: `${newAnalysisFromTemplateOverlayModal}.cancel`,
        tryAgain: `${newAnalysisFromTemplateOverlayModal}.tryAgain`,
    },
    generatePdf: `${reports}.generatePdf`,
    goBack: `${reports}.goBack`,
    openPublishModal: `${reports}.openPublishModal`,
    openRenameInstanceModal: `${reports}.openRenameInstanceModal`,
    openRenameTemplateModal: `${reports}.openRenameTemplateModal`,
    addWidget: `${reports}.addWidget`,
    addTextWidget: `${reports}.addTextWidget`,
    addWidgetModal: {
        search: `${reports}.addWidgetModal.search`,
        category: `${reports}.addWidgetModal.category`,
        close: `${reports}.addWidgetModal.close`,
    },
    editLayout: `${reports}.editLayout`,
    saveLayout: `${reports}.saveLayout`,
    cancelEditLayout: `${reports}.cancelEditLayout`,
    automation: {
        tree: `${reports}.automation.tree`,
        actions: {
            duplicate: `${reports}.automation.actions.duplicate`,
            deactivate: `${reports}.automation.actions.deactivate`,
            delete: `${reports}.automation.actions.delete`,
        },
    },
};
